import { Box, Container, Link, Grid, Typography, useTheme } from "@mui/material";
import Image from "next/image";
import React from "react";
export const InstagramFeed = ({ posts = [], sectionContainer = {} }) => {
    const theme = useTheme();
    const bgColor = theme.palette.grey[50];
    return (React.createElement(Box, { component: "section", id: "editions", sx: {
            backgroundColor: bgColor,
            boxShadow: "sectionTop",
            position: "relative",
            zIndex: 4,
            ...sectionContainer,
        } },
        React.createElement(Container, { maxWidth: "xl", sx: {
                pt: { xs: 6, sm: 6, md: 8, lg: 12, xl: 14 },
                pb: { xs: 8, sm: 8, md: 10, lg: 12, xl: 14 },
            } },
            React.createElement(Typography, { variant: "overline", sx: { width: "100%", textAlign: "center" } }, "Auf Instagram"),
            React.createElement(Typography, { component: "h3", variant: "h2", sx: { pb: 4, width: "100%", textAlign: "center" } }, "@culinario.mortale"),
            React.createElement(Grid, { container: true, spacing: { xs: 2, sm: 3, md: 4 } }, posts.map(({ caption, id, image, permalink }) => (React.createElement(Grid, { key: `ig-feed-${id}`, item: true, xs: 6, sm: 3 },
                React.createElement(Link, { href: permalink, sx: { display: "flex      " } },
                    React.createElement(Image, { ...image, alt: caption, sizes: `
                    (max-width: 767px) 25vw,
                    (min-width: 768px) 20vw,
                    25vw
                  `, style: {
                            aspectRatio: "1 / 1",
                            borderRadius: theme.shape.borderRadius,
                            height: "auto",
                            objectFit: "cover",
                            width: "100%",
                        } })))))))));
};
//# sourceMappingURL=instagram-feed.js.map